import {useQuery, gql} from "@apollo/client";

var  HEADER_MENU_LIST = gql`
query HeaderMenuList {
  menu(where: {displayText: "Header Menu FA", localization: {culture_starts_with: "fa"}}) {
    displayText
    menuItemsList {
      contentItems {
        ... on LinkMenuItem {
          id
          megaMenu
          displayText
          linkMenuItem {
            url
            name
          }
          bag {
            contentItems {
              ... on LinkMenuItem {
                id
                linkMenuItem {
                  name
                  url
                }
                megaMenu
                bag {
                  contentItems {
                    ... on LinkMenuItem {
                      id
                      displayText
                      linkMenuItem {
                        url
                      }
                      megaMenu
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
  
`;

export const useHeaderMenuList = () => {
  const {error, loading, data} = useQuery(HEADER_MENU_LIST);
  
  return {
    error, data, loading
  };
  }